// extracted by mini-css-extract-plugin
module.exports = {"popper":"s_popper__25iD1","hide":"s_hide__3S-1m","target":"s_target__3yqOM","hideUnderline":"s_hideUnderline__bQqcb","arrow":"s_arrow__1mnNf"};